module.exports = __webpack_public_path__ + "static/img/menage7.13628532.png";